export enum Operation {
  Supervise = 'supervise',
  Create = 'create',
  Read = 'read',
  Update = 'update',
  Delete = 'delete',
}
